import { render, staticRenderFns } from "./AccountTabs.vue?vue&type=template&id=de21896e"
import script from "./AccountTabs.vue?vue&type=script&lang=js"
export * from "./AccountTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports